import { apiClient } from './http.api';

// Proxy routes on backend
const FAICON_PROXY_BASE_URL = '/api/reports/faicon';

export const faiconApi = {
  // Get all events from Faicon
  getAllEvents: async () => {
    try {
      const response = await apiClient.get(`${FAICON_PROXY_BASE_URL}/events`, {
        params: { sort_by: 'name', sort_type: 'asc', limit: 1000 }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Faicon events:', error);
      throw error;
    }
  },

  // Get sessions for a specific event
  getSessionsByEvent: async (eventId) => {
    try {
      const response = await apiClient.get(
        `${FAICON_PROXY_BASE_URL}/events/${eventId}/sessions`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching Faicon sessions:', error);
      throw error;
    }
  },

  // Get all sessions
  getAllSessions: async () => {
    try {
      const response = await apiClient.get(`${FAICON_PROXY_BASE_URL}/sessions/all`, {
        params: { sort_by: 'name', sort_type: 'asc', limit: 1000 }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Faicon sessions:', error);
      throw error;
    }
  },

  // Get session by ID
  getSessionById: async (sessionId) => {
    try {
      const response = await apiClient.get(
        `${FAICON_PROXY_BASE_URL}/sessions/${sessionId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching Faicon session by ID:', error);
      throw error;
    }
  }
};

// Export individual functions for backward compatibility
export const {
  getAllEvents,
  getSessionsByEvent,
  getAllSessions,
  getSessionById
} = faiconApi;

// Legacy exports for backward compatibility
export const fetchFaiconEvents = faiconApi.getAllEvents;
export const fetchFaiconSessions = faiconApi.getAllSessions;